import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import "../Services/Service.css";
import "./contact.css";
import { SlLocationPin } from "react-icons/sl";
import { PiPhoneCall } from "react-icons/pi";
import { BsClockHistory } from "react-icons/bs";

import first_add from "../../../img/contact/firstadd.png";
import second_add from "../../../img/contact/secondadd.png";

import third_add from "../../../img/contact/thirdadd.jpg";
import fourth_add from "../../../img/contact/fourth.png";
import fifth_add from "../../../img/contact/fifthadd.jpg";
import sixth_add from "../../../img/contact/sixthadd.jpg";
import seventh_add from "../../../img/contact/seventhadd.jpg";
import eigth_add from "../../../img/contact/eigthadd.jpeg";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { contactAdd } from "../../../Helper/Redux/API";
import { toast } from "react-toastify";
import { Helmet } from 'react-helmet-async';

export default function Contact() {
  const dispatch = useDispatch();
  const initialValue = {
    first_name: "",
    last_name: "",
    email: "",
    contact: "",
    dob: "",
    message: "",
  };

  const validation = yup.object({
    first_name: yup
      .string()
      .matches(
        /^[a-zA-Z\s]+$/,
        "First Name can only contain alphabetic characters and spaces"
      )
      .required("First Name is required"),
    last_name: yup
      .string()
      .matches(
        /^[a-zA-Z\s]+$/,
        "Last Name can only contain alphabetic characters and spaces"
      )
      .required("Last Name is required"),
    email: yup
      .string()
      .required("Email is required")
      .email("Please enter valid email"),
    contact: yup
      .string()
      .matches(/^[0-9]+$/, "Phone Number can only contain digits")

      .required("Contact is required"),
    dob: yup.string().required("Appointment Date"),
    message: yup.string().required("Message is required*"),
  });

  const handlesubmit = (values, { resetForm }) => {
    const requestOption = {
      first_name: values?.first_name,
      last_name: values?.last_name,
      dob: values?.dob,
      email: values?.email,
      message: values?.message,
      mob_no: values?.contact,
    };
    try {
      dispatch(contactAdd(requestOption)).then((res) => {
        if (res?.payload.status === true) {
          toast.success(res?.payload?.message);
          resetForm();
        } else {
          toast.error(res?.payload?.message);
        }
      });
    } catch (error) {
      console.log(error, "Error from Contact Page");
    }
  };

  return (
    <>
        <Helmet>
      <title>Contact Us | Hearing Aid | The Hearing Centre Singapore Locations</title>
        <meta name="description" content="Contact The Hearing Centre for all your Hearing Aid needs. We have 7 branches in Singapore. Call us today to consult our Audiologists." />
        <meta property="og:title" content="Contact Us | Hearing Aid | The Hearing Centre Singapore Locations"></meta>
        <meta property="og:description" content="Contact The Hearing Centre for all your Hearing Aid needs. We have 7 branches in Singapore. Call us today to consult our Audiologists."></meta>
   
    </Helmet>
      <Header />
      <section className="hearing_contact">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <h1 className="contact_heading">Contact Us</h1>
              <p>
                Get to know more about hearing aids/hearing test or simply
                consult our audiologists, for all your hearing needs… get in
                touch with us today.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="contact_happy_section">
        <div className="container">
          <h1 className="contact_happy">We Will Be Happy To Help You.</h1>
          <p className="contact_pergrap">Contact Us To Know More…</p>
          <div className="hr_line"></div>
          <div className="row justify-content-center gap-4 gap-lg-0 ">
            <div className="col-md-6 col-lg-4">
              <div className="col_outer_container">
                <div className="image_container">
                  <div id="hexagon">
                    <SlLocationPin className="contact_page_icon" />
                  </div>
                </div>
                <div className="col_desc_cont">
                  <p className="contact_card_title">Main Office</p>
                  <p>
                    Lucky Plaza – Main Branch 304 Orchard Road 05-36 Lucky
                    Plaza, Singapore 238863
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="col_outer_container">
                <div className="image_container">
                  <div id="hexagon">
                    <PiPhoneCall className="contact_page_icon" />
                  </div>
                </div>
                <div className="col_desc_cont">
                  <p className="contact_card_title">Call Today</p>
                  <p> Telephone: +65 6474 2216 </p>
                  <p>Fax: +65 6732 0034</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mt-0 mt-md-3 mt-lg-0">
              <div className="col_outer_container">
                <div className="image_container">
                  <div id="hexagon">
                    <BsClockHistory className="contact_page_icon" />
                  </div>
                </div>
                <div className="col_desc_cont">
                  <p className="contact_card_title">Business Hours</p>
                  <p>Monday – Friday: 9.30 to 5.30 </p>
                  <p>Saturday: 9.30 to 12.30</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact_address_section">
        <div className="container">
          <h1 className="contact_happy text-center">BRANCH</h1>
          <div className="row">
            <div className="col-md-6 col-lg-4">
              <div class="card">
                <img src={first_add} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h6 class="card-title">Telephone </h6>
                  <p class="card-text">
                    2 Jurong East Street 21, #03-179 IMM Building, Singapore
                    609601
                  </p>
                  <h5>
                    Telephone: <a href="#">+65 6474 2216</a>
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div class="card">
                <img src={second_add} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h6 class="card-title"> LUCKY PLAZA – MAIN BRANCH </h6>
                  <p class="card-text">
                    304 Orchard Road #05-36 Lucky Plaza Singapore 238863
                  </p>
                  <h5>
                    Telephone: <a href="#">+65 6474 2216</a>
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div class="card">
                <img src={third_add} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h6 class="card-title">
                    {" "}
                    NORTH BRIDGE ROAD (RAFFLE’S ENT CENTRE) BRANCH{" "}
                  </h6>
                  <p class="card-text">
                    585 North Bridge Road,Raffles Specialist Centre, 08-00
                    Singapore 188770
                  </p>
                  <h5>
                    Telephone: <a href="#">+65 6474 2216</a>
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div class="card">
                <img src={fourth_add} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h6 class="card-title"> PASIR RIS BRANCH </h6>
                  <p class="card-text">
                    Blk 258, Loyang Point, Pasir Ris Street 21, #01-14 (inside
                    Alchemy Pharmacy) Singapore 510258
                  </p>
                  <h5>
                    Telephone: <a href="#">+65 6474 2216</a>
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div class="card">
                <img src={fifth_add} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h6 class="card-title"> AMK BRANCH</h6>
                  <p class="card-text">
                    Blk 710A Ang Mo Kio Avenue 8, #01-2625 (opp AMK MRT, next to
                    Cash Converter) Singapore 561710
                  </p>
                  <h5>
                    Telephone: <a href="#">+65 6474 2216</a>
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div class="card">
                <img src={sixth_add} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h6 class="card-title"> TAMPINES BRANCH </h6>
                  <p class="card-text">
                    300 Tampines Avenue 5 #09-02 (inside Regus) Tampines
                    Junction (NTUC Centre), Singapore 529653
                  </p>
                  <h5>
                    Telephone: <a href="#">+65 6474 2216</a>
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div class="card">
                <img src={seventh_add} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h6 class="card-title"> EAST COAST BRANCH </h6>
                  <p class="card-text">
                    713 East Coast Road (inside First Eyewear) , Singapore
                    459066
                  </p>
                  <h5>
                    Telephone: <a href="#">+65 6474 2216</a>
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div class="card">
                <img src={eigth_add} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h6 class="card-title"> 23C,RUSSIAN FEDERATION BLVD </h6>
                  <p class="card-text">
                    Sangkat Tuek Thla, Khan Sen Sok, Phnom Penh.
                  </p>
                  <h5>
                    Telephone: <a href="#">+65 6474 2216</a>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact_form">
        <div className="container">
          <h1 className="contact_happy text-center">Contact Form</h1>
          <p>
            We will be happy to help you. Book an appointment with us today!
          </p>
          <Formik
            validationSchema={validation}
            onSubmit={handlesubmit}
            initialValues={initialValue}
          >
            <Form>
              <div className="row">
                <div className="col-md-6">
                  <div className="form_input">
                    <Field
                      type="text"
                      id="login_fname"
                      placeholder="Enter First Name"
                      name="first_name"
                    />
                    <ErrorMessage
                      name="first_name"
                      className="text-danger text-start fw-bolder fs-6"
                      component={"p"}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form_input">
                    <Field
                      name="last_name"
                      type="text"
                      id="Last_fname"
                      placeholder="Enter Last Name"
                    />
                    <ErrorMessage
                      name="last_name"
                      className="text-danger text-start fw-bolder fs-6"
                      component={"p"}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form_input">
                    <Field
                      name="email"
                      type="email"
                      id="login_emil"
                      placeholder="Enter  Email"
                    />
                    <ErrorMessage
                      name="email"
                      className="text-danger text-start fw-bolder fs-6"
                      component={"p"}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form_input">
                    <Field
                      name="contact"
                      type="text"
                      id="Phonenumber"
                      placeholder="Enter Phone Number"
                    />
                    <ErrorMessage
                      name="contact"
                      className="text-danger text-start fw-bolder fs-6"
                      component={"p"}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form_input">
                    <Field
                      name="dob"
                      type="datetime-local"
                      id="AppointmentDate"
                      placeholder="Appointment Date"
                    />
                    <ErrorMessage
                      name="dob"
                      className="text-danger text-start fw-bolder fs-6"
                      component={"p"}
                    />
                  </div>
                </div>
                {/* 
            <div className="col-md-6">
              <div className="form_input time_text">
                <input
                  name="Hours"
                  type="text"
                  id="Hours"
                  placeholder="Hours"
                />
                <input
                  name="Minutes"
                  type="text"
                  id="Minutes"
                  placeholder="Minutes"
                />

                <select
                  name="nationality"
                  aria-label="Nationality"
                  className="form-select"
                >
                  <option value="AM" disabled="">
                    AM
                  </option>
                  <option value="PM">PM</option>
                </select>
              </div>
            </div> */}

                <div className="col-md-12">
                  <div className="form_input">
                    <Field
                      as="textarea"
                      name="message"
                      id="Message"
                      placeholder="Message"
                      rows="8"
                    />
                    <ErrorMessage
                      name="message"
                      className="text-danger text-start fw-bolder fs-6"
                      component={"p"}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <button className="btn contact-btn" type="submit">
                    Send Message
                  </button>
                </div>
              </div>
            </Form>
          </Formik>
        </div>
      </section>
      <Footer />
    </>
  );
}
